/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Import_CancelledInputs */

const en_editor_import_cancelled = /** @type {(inputs: Editor_Import_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import cancelled`)
};

const fr_editor_import_cancelled = /** @type {(inputs: Editor_Import_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation annulee`)
};

const de_editor_import_cancelled = /** @type {(inputs: Editor_Import_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import storniert`)
};

const it_editor_import_cancelled = /** @type {(inputs: Editor_Import_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione annullata`)
};

const ru_editor_import_cancelled = /** @type {(inputs: Editor_Import_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт отменен`)
};

const es_editor_import_cancelled = /** @type {(inputs: Editor_Import_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación cancelada`)
};

const zh_cn2_editor_import_cancelled = /** @type {(inputs: Editor_Import_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进口取消`)
};

const ja_editor_import_cancelled = /** @type {(inputs: Editor_Import_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入はキャンセルされました`)
};

const hi_editor_import_cancelled = /** @type {(inputs: Editor_Import_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात रद्द कर दिया गया`)
};

const pt_pt2_editor_import_cancelled = /** @type {(inputs: Editor_Import_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação cancelada`)
};

/**
* | output |
* | --- |
* | "Import cancelled" |
*
* @param {Editor_Import_CancelledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_import_cancelled = /** @type {((inputs?: Editor_Import_CancelledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Import_CancelledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_import_cancelled(inputs)
	if (locale === "de") return de_editor_import_cancelled(inputs)
	if (locale === "it") return it_editor_import_cancelled(inputs)
	if (locale === "ru") return ru_editor_import_cancelled(inputs)
	if (locale === "es") return es_editor_import_cancelled(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_import_cancelled(inputs)
	if (locale === "ja") return ja_editor_import_cancelled(inputs)
	if (locale === "hi") return hi_editor_import_cancelled(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_import_cancelled(inputs)
	return en_editor_import_cancelled(inputs)
});